import {useState} from 'react'
import Sidebar from '../Sidebar/Sidebar'
import Header from '../Nav Bar/Header';
import ShortcutButton from '../Layout Shortcut/Shortcut';
import Cookies from 'js-cookie';
import { Outlet } from 'react-router-dom';
 
 
function Layout() {
  const encoded_token = Cookies.get('token');
 
  const [open, setOpen] = useState(false);
  const toggleSidebar = () => {
    setOpen(!open);
  };
 
  if (!encoded_token) {
    window.location.href = '/';
    return null;
  } else {
    return (
      <div className="main">
      <Sidebar open={open} toggleSidebar={toggleSidebar} />
      <div className="headerandcontainer">
        <Header toggleSidebar={toggleSidebar} />
        <Outlet />
        <ShortcutButton />
      </div>
    </div>
    )
  }
}
 
export default Layout;
 
 